/**
 * @description
 * Objeto typeruns
 */

export class Typeruns {
    public id:number = null;
    public code:string = "";

    constructor() {}
  
}